import React, { useEffect, useRef, useState } from "react";
import { Button, Card, Col, Divider, Drawer, Form, Input, Popconfirm, Row, Select, Space, Switch, Table, Tag, Upload } from 'antd'
import { FgPriceListRequest, FgPriceListResponseModel } from "@gtpl/shared-models/masters";
import { ColumnProps } from "antd/lib/table";
import { CheckCircleOutlined, CloseCircleOutlined, RightSquareOutlined, EyeOutlined, EditOutlined, SearchOutlined } from '@ant-design/icons';
import Highlighter from 'react-highlight-words';
import { Link } from "react-router-dom";
import { FileExcelFilled } from "@ant-design/icons";
import { Excel } from "antd-table-saveas-excel";
import { FgPriceListService, SuppliersService } from "@gtpl/shared-services/masters";
import moment from "moment";

export function FarmersGrid() {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState<number>(100);
  const service = new SuppliersService()
  const [data, setData] = useState([])
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);

  useEffect(() => {
    getInfo()
  }, [])

  const getInfo = () => {
    service.getAllFarmersInfo().then(res => {
      if (res.status) {
        setData(res.data)
      }
    })
  }

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };

  ;
  const getColumnSearchProps = (dataIndex: string) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          size="small"
          style={{ width: 90 }}
          onClick={() => {
            handleReset(clearFilters);
            setSearchedColumn(dataIndex);
            confirm({ closeDropdown: true });
          }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        type="search"
        style={{ color: filtered ? "#1890ff" : undefined }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase())
        : false,
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current.select());
      }
    },
    render: (text) =>
      text ? (
        searchedColumn === dataIndex ? (
          <Highlighter
            highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={text.toString()}
          />
        ) : (
          text
        )
      ) : null,
  });

    
  const columns: any[] = [
    {
      title: 'S No', dataIndex: 'sNo', render: (text, object, index) => {
        if (index == data.length) {
          return null;
        } else {
          return index + 1
        }
      },
      width: 60,

    },
    {
      title: 'Uploaded Date', 
     width: 200,
     dataIndex: 'updatedAt',
      render: (value, record) => {
        return moment(record.updatedAt).format('DD-MM-YYYY');
    },
      sorter: (a, b) => a.updatedAt.localeCompare(b.updatedAt),
      sortDirections: ['descend', 'ascend'],
     },

    {
       title: 'Farmer Name', 
      width: 200,
      dataIndex: 'supplierName',

        render: (text: any, record: any) => { return record.supplierName ? record.supplierName : '-' } ,
        sorter: (a, b) => a.supplierName.localeCompare(b.supplierName),
      sortDirections: ['descend', 'ascend'],
     ...getColumnSearchProps('supplierName')
      },

    {
       title: 'Farmer Code', 
      width: 200,
      dataIndex: 'supplierCode',

        render: (text: any, record: any) => { return record.supplierCode ? record.supplierCode : '-' } ,
        sorter: (a, b) => a.supplierCode.localeCompare(b.supplierCode),
      sortDirections: ['descend', 'ascend'],
     ...getColumnSearchProps('supplierCode')},
    {
       title: 'Farm Type', 
      width: 200,
      dataIndex: 'farm_type',

        render: (text: any, record: any) => { return record.farm_type ? record.farm_type : '-' } ,
        sorter: (a, b) => a.farm_type.localeCompare(b.farm_type),
      sortDirections: ['descend', 'ascend'],
     ...getColumnSearchProps('farm_type')},
    {
       title: 'Place', 
      width: 200,
      dataIndex: 'city', 
        render: (text: any, record: any) => { return record.city ? record.city : '-' } ,
        sorter: (a, b) => a.city.localeCompare(b.city),
      sortDirections: ['descend', 'ascend'],
     ...getColumnSearchProps('city')},
    {
       title: 'District', 
      width: 200,
      dataIndex: 'district',

        render: (text: any, record: any) => { return record.district ? record.district : '-' } ,
        sorter: (a, b) => a.district.localeCompare(b.district),
      sortDirections: ['descend', 'ascend'],
     ...getColumnSearchProps('district')},
    {
       title: 'State', 
      width: 200,
      dataIndex: 'state',

        render: (text: any, record: any) => { return record.state ? record.state : '-' } ,
        sorter: (a, b) => a.state.localeCompare(b.state),
      sortDirections: ['descend', 'ascend'],
     ...getColumnSearchProps('state')},
    {
       title: 'Contact Number', 
      width: 200,
      dataIndex: 'contactNumber',

        render: (text: any, record: any) => { return record.contactNumber ? record.contactNumber : '-' } ,
        sorter: (a, b) => a.contactNumber.localeCompare(b.contactNumber),
      sortDirections: ['descend', 'ascend'],
     ...getColumnSearchProps('contactNumber')},
    {
       title: 'MPEDA Registration Status', 
      width: 200,
      dataIndex: 'reg_status',

        render: (text: any, record: any) => { return record.reg_status ? 'Yes' : 'No' } ,
        },
    {
       title: 'MPEDA Registration No', 
      width: 200,
      dataIndex: 'reg_no',

        render: (text: any, record: any) => { return record.reg_no ? record.reg_no : '-' } ,
        },
    {
       title: 'Farm Name', 
      width: 200,
      dataIndex: 'farmName',

        render: (text: any, record: any) => { return record.farmName ? record.farmName : '-' },
        sorter: (a, b) => a.farmName.localeCompare(b.farmName),
      sortDirections: ['descend', 'ascend'],
     ...getColumnSearchProps('farmName')
     },
    {
       title: 'Farm Code', 
      width: 200,
      dataIndex: 'farmCode',

        render: (text: any, record: any) => { return record.farmCode ? record.farmCode : '-' },
        sorter: (a, b) => a.farmCode.localeCompare(b.farmCode),
      sortDirections: ['descend', 'ascend'],
     ...getColumnSearchProps('farmCode')
     },
    {
       title: 'Farm Address', 
      width: 200,
      dataIndex: 'farmAddress',

        render: (text: any, record: any) => { return record.farmAddress ? record.farmAddress : '-' },
        sorter: (a, b) => a.farmAddress.localeCompare(b.farmAddress),
      sortDirections: ['descend', 'ascend'],
     ...getColumnSearchProps('farmAddress')
     },
    {
       title: 'No. of Acr', 
      width: 200,
      dataIndex: 'noOfAcr',

        render: (text: any, record: any) => { return record.noOfAcr ? record.noOfAcr : '-' },
        sorter: (a, b) => a.noOfAcr.localeCompare(b.noOfAcr),
      sortDirections: ['descend', 'ascend'],
     },
    {
       title: 'No. of Ponds', 
      width: 200,
      dataIndex: 'noOfPonds',

        render: (text: any, record: any) => { return record.noOfPonds ? record.noOfPonds : '-' },
        sorter: (a, b) => a.noOfPonds.localeCompare(b.noOfPonds),
      sortDirections: ['descend', 'ascend'],
     },
    {
       title: 'Trace Code', 
      width: 200,
      dataIndex: 'traceCode',

        render: (text: any, record: any) => { return record.traceCode ? record.traceCode : '-' },
        sorter: (a, b) => a.traceCode.localeCompare(b.traceCode),
      sortDirections: ['descend', 'ascend'],
     ...getColumnSearchProps('traceCode')
     },
    {
       title: 'Certification', 
      width: 200,
      dataIndex: 'certification',

        render: (text: any, record: any) => { return record.certification ? record.certification : '-' },
        sorter: (a, b) => a.certification.localeCompare(b.certification),
      sortDirections: ['descend', 'ascend'],
     ...getColumnSearchProps('certification')
     },
    {
       title: 'Certification Code', 
      width: 200,
      dataIndex: 'certificationCode',

        render: (text: any, record: any) => { return record.certificationCode ? record.certificationCode : '-' },
        sorter: (a, b) => a.certificationCode.localeCompare(b.certificationCode),
      sortDirections: ['descend', 'ascend'],
     ...getColumnSearchProps('certificationCode')
     },
    {
       title: 'Expiry Date', 
      width: 200,
      dataIndex: 'expiryDate',

        render: (text: any, record: any) => { return record.expiryDate ? moment(record.expiryDate).format('DD-MM-YYYY') : '-' },
        sorter: (a, b) => a.expiryDate.localeCompare(b.expiryDate),
      sortDirections: ['descend', 'ascend'],
     },
    {
       title: 'Culture Status', 
      width: 200,
      dataIndex: 'cultureStatus',

        render: (text: any, record: any) => { return record.cultureStatus ? 'Yes' : 'No' },
        sorter: (a, b) => a.cultureStatus.localeCompare(b.cultureStatus),
      sortDirections: ['descend', 'ascend'],
     },
    {
       title: 'Area under culture in acrs', 
      width: 100,
      dataIndex: 'cultureInAcr',

        render: (text: any, record: any) => { return record.cultureInAcr ? record.cultureInAcr : '-' },
        sorter: (a, b) => a.cultureInAcr.localeCompare(b.cultureInAcr),
      sortDirections: ['descend', 'ascend'],
     },
    {
       title: 'Data of Stock in', 
      width: 100,
      dataIndex: 'dataOfStockIn',

        render: (text: any, record: any) => { return record.dataOfStockIn ? record.dataOfStockIn : '-' },
        sorter: (a, b) => a.dataOfStockIn.localeCompare(b.dataOfStockIn),
      sortDirections: ['descend', 'ascend'],
     },
    {
       title: 'Qty of Stock-in(Millions)', 
      width: 100,
      dataIndex: 'qtyStock',

        render: (text: any, record: any) => { return record.qtyStock ? record.qtyStock : '-' },
        sorter: (a, b) => a.qtyStock.localeCompare(b.qtyStock),
      sortDirections: ['descend', 'ascend'],
    //  ...getColumnSearchProps('qtyStock')
     },
    {
       title: 'Dealer Name', 
       dataIndex: 'dealer',
       width: 200,

        render: (text: any, record: any) => { return record.dealer ? record.dealer : '-' },
        sorter: (a, b) => a.dealer.localeCompare(b.dealer),
      sortDirections: ['descend', 'ascend'],
     ...getColumnSearchProps('dealer')
     },
    {
       title: 'Feed', 
       dataIndex: 'feed',
       width: 200,

        render: (text: any, record: any) => { return record.feed ? record.feed : '-' },
        sorter: (a, b) => a.feed.localeCompare(b.feed),
      sortDirections: ['descend', 'ascend'],
     ...getColumnSearchProps('feed')
     },
    {
       title: 'Seed', 
       dataIndex: 'seed',
       width: 200,

        render: (text: any, record: any) => { return record.seed ? record.seed : '-' },
        sorter: (a, b) => a.seed.localeCompare(b.seed),
      sortDirections: ['descend', 'ascend'],
     ...getColumnSearchProps('seed')
     },
    {
       title: 'DOC', 
       dataIndex: 'doc',
       width: 100,

        render: (text: any, record: any) => { return record.doc ? record.doc : '-' },
        sorter: (a, b) => a.doc.localeCompare(b.doc),
      sortDirections: ['descend', 'ascend'],
    //  ...getColumnSearchProps('doc')
     },
    {
       title: 'Count', 
       dataIndex: 'count',
       width: 100,

        render: (text: any, record: any) => { return record.count ? record.count : '-' },
        sorter: (a, b) => a.count.localeCompare(b.count),
      sortDirections: ['descend', 'ascend'],
     ...getColumnSearchProps('count')
     },
    {
       title: 'Biomass in Mts', 
       dataIndex: 'biomass',
       width: 100,
       render: (text: any, record: any) => { return record.biomass ? record.biomass : '-' },
        sorter: (a, b) => a.biomass.localeCompare(b.biomass),
      sortDirections: ['descend', 'ascend'],
     },
    {
       title: 'Remarks', 
       dataIndex: 'remarks',
       width: 200,

        render: (text: any, record: any) => { return record.remarks ? record.remarks : '-' },
    //     sorter: (a, b) => a.supplierName.localeCompare(b.supplierName),
    //   sortDirections: ['descend', 'ascend'],
    //  ...getColumnSearchProps('supplierName')
     },
    {
       title: 'Comments', 
       dataIndex: 'comments',
       width: 200,

        render: (text: any, record: any) => { return record.comments ? record.comments : '-' },
    //     sorter: (a, b) => a.supplierName.localeCompare(b.supplierName),
    //   sortDirections: ['descend', 'ascend'],
    //  ...getColumnSearchProps('supplierName')
     },

  ]

  let i = 1;
  let rowIndex = 1;
 
const  exceldata =  [
  {
    title: 'S No', dataIndex: 'sNo', render: (text, object, index) => {
      if (index == data.length) {
        return null;
      } else {
        return index + 1
      }
    },
    width: 60,

  },
  {
    title: 'Uploaded Date', 
   dataIndex: 'updatedAt',
    render: (value, record) => {
      return moment(record.updatedAt).format('DD-MM-YYYY');
  },
   },
  {
     title: 'Farmer Name', 
     dataIndex: 'supplierName',

      render: (text: any, record: any) => { return record.supplierName ? record.supplierName : '-' },
        sorter: (a, b) => a.supplierName.localeCompare(b.supplierName),
      sortDirections: ['descend', 'ascend'],
     ...getColumnSearchProps('supplierName')},
  {
     title: 'Farmer Code', 
     dataIndex: 'supplierCode',

      render: (text: any, record: any) => { return record.supplierCode ? record.supplierCode : '-' },
        sorter: (a, b) => a.supplierName.localeCompare(b.supplierName),
      sortDirections: ['descend', 'ascend'],
     ...getColumnSearchProps('supplierName')},
  {
     title: 'Farm Type', 
     dataIndex: 'farm_type',

      render: (text: any, record: any) => { return record.farm_type ? record.farm_type : '-' },
        sorter: (a, b) => a.supplierName.localeCompare(b.supplierName),
      sortDirections: ['descend', 'ascend'],
     ...getColumnSearchProps('supplierName')},
  {
     title: 'Place', 
     dataIndex: 'city', width: 500, 
      render: (text: any, record: any) => { return record.city ? record.city : '-' },
        sorter: (a, b) => a.supplierName.localeCompare(b.supplierName),
      sortDirections: ['descend', 'ascend'],
     ...getColumnSearchProps('supplierName')},
  {
     title: 'District', 
     dataIndex: 'district',

      render: (text: any, record: any) => { return record.district ? record.district : '-' },
        sorter: (a, b) => a.supplierName.localeCompare(b.supplierName),
      sortDirections: ['descend', 'ascend'],
     ...getColumnSearchProps('supplierName')},
  {
     title: 'State', 
     dataIndex: 'state',

      render: (text: any, record: any) => { return record.state ? record.state : '-' },
        sorter: (a, b) => a.supplierName.localeCompare(b.supplierName),
      sortDirections: ['descend', 'ascend'],
     ...getColumnSearchProps('supplierName')},
  {
     title: 'Contact Number', 
     dataIndex: 'contactNumber',

      render: (text: any, record: any) => { return record.contactNumber ? record.contactNumber : '-' },
        sorter: (a, b) => a.supplierName.localeCompare(b.supplierName),
      sortDirections: ['descend', 'ascend'],
     ...getColumnSearchProps('supplierName')},
  {
     title: 'MPEDA Registration Status', 
     dataIndex: 'reg_status',

      render: (text: any, record: any) => { return record.reg_status ? 'Yes' : 'No' },
        sorter: (a, b) => a.supplierName.localeCompare(b.supplierName),
      sortDirections: ['descend', 'ascend'],
     ...getColumnSearchProps('supplierName')},
  {
     title: 'MPEDA Registration No', 
     dataIndex: 'reg_no',

      render: (text: any, record: any) => { return record.reg_no ? record.reg_no : '-' },
        sorter: (a, b) => a.supplierName.localeCompare(b.supplierName),
      sortDirections: ['descend', 'ascend'],
     ...getColumnSearchProps('supplierName')},
  {
     title: 'Farm Name', 
     dataIndex: 'farmName',

      render: (text: any, record: any) => { return record.farmName ? record.farmName : '-' }
   },
  {
     title: 'Farm Code', 
     dataIndex: 'farmCode',

      render: (text: any, record: any) => { return record.farmCode ? record.farmCode : '-' }
   },
  {
     title: 'Farm Address', 
     dataIndex: 'farmAddress',

      render: (text: any, record: any) => { return record.farmAddress ? record.farmAddress : '-' }
   },
  {
     title: 'No. of Acr', 
     dataIndex: 'noOfAcr',

      render: (text: any, record: any) => { return record.noOfAcr ? record.noOfAcr : '-' }
   },
  {
     title: 'No. of Ponds', 
     dataIndex: 'noOfPonds',

      render: (text: any, record: any) => { return record.noOfPonds ? record.noOfPonds : '-' }
   },
  {
     title: 'Trace Code', 
     dataIndex: 'traceCode',

      render: (text: any, record: any) => { return record.traceCode ? record.traceCode : '-' }
   },
  {
     title: 'Certification', 
     dataIndex: 'certification',

      render: (text: any, record: any) => { return record.certification ? record.certification : '-' }
   },
  {
     title: 'Certification Code', 
     dataIndex: 'certificationCode',

      render: (text: any, record: any) => { return record.certificationCode ? record.certificationCode : '-' }
   },
  {
     title: 'Expiry Date', 
     dataIndex: 'expiryDate',

      render: (text: any, record: any) => { return record.expiryDate ? moment(record.expiryDate).format('DD-MM-YYYY') : '-' }
   },
  {
     title: 'Culture Status', 
     dataIndex: 'cultureStatus',

      render: (text: any, record: any) => { return record.cultureStatus ? 'Yes' : 'No' }
   },
  {
     title: 'Area under culture in acrs', 
     dataIndex: 'cultureInAcr',

      render: (text: any, record: any) => { return record.cultureInAcr ? record.cultureInAcr : '-' }
   },
  {
     title: 'Data of Stock in', 
     dataIndex: 'dataOfStockIn',

      render: (text: any, record: any) => { return record.dataOfStockIn ? record.dataOfStockIn : '-' }
   },
  {
     title: 'Qty of Stock-in(Millions)', 
     dataIndex: 'qtyStock',

      render: (text: any, record: any) => { return record.qtyStock ? record.qtyStock : '-' }
   },
  {
     title: 'Dealer Name', 
     dataIndex: 'dealer',

      render: (text: any, record: any) => { return record.dealer ? record.dealer : '-' }
   },
  {
     title: 'Feed', 
     dataIndex: 'feed',

      render: (text: any, record: any) => { return record.feed ? record.feed : '-' }
   },
  {
     title: 'Seed', 
     dataIndex: 'seed',

      render: (text: any, record: any) => { return record.seed ? record.seed : '-' }
   },
  {
     title: 'DOC', 
     dataIndex: 'doc',

      render: (text: any, record: any) => { return record.doc ? record.doc : '-' }
   },
  {
     title: 'Count', 
     dataIndex: 'count',

      render: (text: any, record: any) => { return record.count ? record.count : '-' }
   },
  {
     title: 'Biomass in Mts', 
     dataIndex: 'biomass',

      render: (text: any, record: any) => { return record.biomass ? record.biomass : '-' }
   },
  {
     title: 'Remarks', 
     dataIndex: 'remarks',

      render: (text: any, record: any) => { return record.remarks ? record.remarks : '-' }
   },
  {
     title: 'Comments', 
     dataIndex: 'comments',

      render: (text: any, record: any) => { return record.comments ? record.comments : '-' }
   },

]
  const exportExcel = () => {
    const excel = new Excel();
    excel
      .addSheet('Farmers Excel')
      .addColumns(exceldata)
      .addDataSource(data, { str2num: false })
      .saveAs('Farmers Data.xlsx');
  }
  return (
    <Card title={<span style={{ color: 'white' }}>Farmer</span>}
      size='small'
      style={{ color: 'white', textAlign: 'center' }}
      headStyle={{ backgroundColor: "#69c0ff", border: 0 }}
      extra={<Link to='/farmers-excel-upload' >
        <span style={{ color: 'white' }} ><Button className="panel_button" >New</Button> </span>
      </Link>}
    >
      <Row justify={'end'}>
        <Button
          type="default"
          style={{ color: "green", padding: 5 }}
          onClick={exportExcel}
          icon={<FileExcelFilled />}
        >
          Download Excel
        </Button>
      </Row>
      <Table className="custom-table-wrapper" columns={columns} dataSource={data} size='small'
          scroll={{ x: "max-content", y:500 }}
        pagination={{
          pageSize: 100,
          onChange(current, pageSize) {
            setPage(current);
            setPageSize(pageSize);
          }
        }}
      />
    </Card>
  )
}
export default FarmersGrid